var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArraowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 0) scale(-1 1)",
    clipPath: "url(#clip0_28195_254645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 8.1849L7.60256 5.56285C7.39174 5.40015 7.39174 5.13631 7.60256 4.9736L11 2.35156",
    stroke: "#50C878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55566 8.1849L3.15823 5.56285C2.9474 5.40015 2.9474 5.13631 3.15823 4.9736L6.55566 2.35156",
    stroke: "#50C878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28195_254645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 15,
    fill: "white",
    transform: "matrix(0 1 -1 0 15 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArraowRight);
export default __webpack_public_path__ + "static/media/doubleArraowRight.9dc758e8d646a26c8afc5a0bb198b3d1.svg";
export { ForwardRef as ReactComponent };